"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRatio = exports.scaleToConstraints = exports.clampDimensions = exports.factorDimensions = exports.determineConstraintDimension = void 0;
const common_1 = require("@augment-vir/common");
const number_1 = require("./number");
function determineConstraintDimension({ constraint, box, constraintType = 'max', }) {
    const comparison = constraintType === 'max' ? number_1.greaterThan : number_1.lessThan;
    if (comparison(box.width / box.height, constraint.width / constraint.height)) {
        return 'width';
    }
    else {
        return 'height';
    }
}
exports.determineConstraintDimension = determineConstraintDimension;
function calculateConstraintRatio({ box, constraint, constraintType, }) {
    const constraintDimension = determineConstraintDimension({
        box,
        constraint,
        constraintType: constraintType,
    });
    const ratio = constraint[constraintDimension] / box[constraintDimension];
    return ratio;
}
function factorDimensions({ box, ratio }) {
    return (0, common_1.mapObjectValues)(box, (key, value) => value * ratio);
}
exports.factorDimensions = factorDimensions;
function clampDimensions({ box, min, max }) {
    return (0, common_1.mapObjectValues)(box, (axis, originalValue) => {
        var _a, _b;
        return (0, common_1.clamp)({
            value: originalValue,
            min: (_a = min === null || min === void 0 ? void 0 : min[axis]) !== null && _a !== void 0 ? _a : 0,
            max: (_b = max === null || max === void 0 ? void 0 : max[axis]) !== null && _b !== void 0 ? _b : Infinity,
        });
    });
}
exports.clampDimensions = clampDimensions;
function scaleToConstraints({ min, max, box }) {
    const ratio = calculateRatio({
        min,
        max,
        box,
    });
    const resizedBox = factorDimensions({ box, ratio });
    return {
        height: Math.floor(resizedBox.height || (min === null || min === void 0 ? void 0 : min.height) || 250),
        width: Math.floor(resizedBox.width || (min === null || min === void 0 ? void 0 : min.width) || 250), // 250 = idk we have to pick SOMETHING
    };
}
exports.scaleToConstraints = scaleToConstraints;
function calculateRatio({ min, max, box }) {
    if (!min && !max) {
        return 1;
    }
    const minRatio = min
        ? calculateConstraintRatio({
            box,
            constraint: min,
            constraintType: 'min',
        })
        : 1;
    const maxRatio = max
        ? calculateConstraintRatio({
            box,
            constraint: max,
            constraintType: 'max',
        })
        : 1;
    const initialRatio = minRatio > 1 ? minRatio : maxRatio < 1 ? maxRatio : 1;
    const factoredBox = factorDimensions({ ratio: initialRatio, box });
    const doubleMinRatio = min
        ? calculateConstraintRatio({
            box: factoredBox,
            constraint: min,
            constraintType: 'min',
        })
        : 1;
    if (doubleMinRatio > 1) {
        return minRatio;
    }
    else {
        return initialRatio;
    }
}
exports.calculateRatio = calculateRatio;
